/**
 * Alatreyu Account Reviews Helper
 *
 * When a customer visits a product page with ?review=true (linked from
 * order history, post-delivery email, etc.), this script:
 * 1. Scrolls to the review section
 * 2. Pre-fills their email if logged in
 * 3. Optionally opens the review form if the app supports it
 *
 * Works with Judge.me, Shopify Product Reviews, and other common apps.
 */
(function () {
  'use strict';

  // Check for ?review=true or #reviews hash
  var params = new URLSearchParams(window.location.search);
  var shouldReview = params.get('review') === 'true';
  var hasHash = window.location.hash === '#reviews';

  if (!shouldReview && !hasHash) return;

  // Selectors for review sections across common apps
  var REVIEW_SECTION_SELECTORS = [
    '#judgeme_product_reviews',         // Judge.me
    '#shopify-product-reviews',        // Shopify Product Reviews
    '.jdgm-widget',                    // Judge.me widget
    '.spr-container',                  // SPR container
    '.stamped-main-widget',            // Stamped.io
    '.yotpo-widget-instance',          // Yotpo
    '.loox-reviews-default',           // Loox
    '[data-reviews-section]',          // Generic
    '#reviews',                        // Common ID
  ];

  // Selectors for "Write a Review" buttons
  var WRITE_REVIEW_SELECTORS = [
    '.jdgm-write-rev-link',            // Judge.me
    '.spr-summary-actions-newreview',   // Shopify Product Reviews
    '.stamped-summary-actions-newreview', // Stamped.io
    '.write-review-btn',               // Generic
    '[data-write-review]',             // Generic data attribute
  ];

  // Selectors for email input fields in review forms
  var EMAIL_INPUT_SELECTORS = [
    '.jdgm-form input[type="email"]',  // Judge.me
    '.spr-form-input[name="review[author_email]"]', // SPR
    '.review-form input[type="email"]', // Generic
    '[data-review-email]',             // Generic
  ];

  /**
   * Try to find the review section element
   */
  function findReviewSection() {
    for (var i = 0; i < REVIEW_SECTION_SELECTORS.length; i++) {
      var el = document.querySelector(REVIEW_SECTION_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  /**
   * Try to click the "Write a Review" button
   */
  function clickWriteReview() {
    for (var i = 0; i < WRITE_REVIEW_SELECTORS.length; i++) {
      var btn = document.querySelector(WRITE_REVIEW_SELECTORS[i]);
      if (btn) {
        btn.click();
        return true;
      }
    }
    return false;
  }

  /**
   * Try to pre-fill the email field
   */
  function prefillEmail() {
    // Customer email is set by Liquid in theme.liquid
    var email = window.alatreyuCustomerEmail;
    if (!email) return;

    for (var i = 0; i < EMAIL_INPUT_SELECTORS.length; i++) {
      var input = document.querySelector(EMAIL_INPUT_SELECTORS[i]);
      if (input && !input.value) {
        input.value = email;
        // Trigger change event so the app validates the field
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }
    }
  }

  /**
   * Scroll to reviews with smooth animation
   */
  function scrollToReviews() {
    var section = findReviewSection();
    if (!section) return false;

    // Offset for fixed header
    var headerHeight = 80;
    var top = section.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({
      top: top,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });

    return true;
  }

  /**
   * Main activation: scroll, open form, prefill
   */
  function activate() {
    var scrolled = scrollToReviews();

    if (scrolled) {
      // Wait a beat for scroll to complete, then open form + prefill
      setTimeout(function () {
        clickWriteReview();
        setTimeout(prefillEmail, 500);
      }, 600);
    }
  }

  /**
   * Wait for a review widget to appear, then activate.
   * Review apps load asynchronously so we need to poll or observe.
   */
  function waitForReviews() {
    var attempts = 0;
    var maxAttempts = 30; // 30 × 500ms = 15 seconds max
    var interval = setInterval(function () {
      attempts++;
      var section = findReviewSection();

      if (section) {
        clearInterval(interval);
        // Give the widget a moment to fully render
        setTimeout(activate, 300);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        // No review widget found — try scrolling to #reviews anchor if it exists
        var anchor = document.getElementById('reviews');
        if (anchor) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, 500);
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForReviews);
  } else {
    waitForReviews();
  }
})();
